import { OrganizationsPages } from '@/modules/organizations/shared/types';
import { all_internal_roles } from '@/utils';

const access_roles = {
  [OrganizationsPages.ORGANIZATIONS]: all_internal_roles,
  [OrganizationsPages.ORGANIZATION_DETAIL]: all_internal_roles,
  [OrganizationsPages.ORGANIZATION_EDIT]: all_internal_roles,
  [OrganizationsPages.ORGANIZATION_CHECK]: all_internal_roles, // TODO: Какие права выдавать?
};

export default access_roles;
